// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__GpJ+p","checkbox":"Checkbox_checkbox__7wKay","error":"Checkbox_error__E5UCd"};